import { memo } from 'react';
import { ActionPanelState } from './ActionPanelTypes';
import { ActivityPanel } from './ActivityPanel';
import CommentsPanel from './CommentsPanel';
import AboutStagePanel from './AboutStagePanel';
import PublicationStatePanel from './PublicationStatePanel';
import BarRaiserEvaluationPanel from './BarRaiserEvaluationPanel';
import { useActionPanelState } from '../v2-hooks/useActionPanelState';
import InfoPanel from './InfoPanel';

/**
 * Resolves the active panel ID to the correct panel component.
 */
function renderPanel(activePanel: ActionPanelState): React.ReactNode {
  switch (activePanel) {
    case 'publication-state':
      return <PublicationStatePanel />;
    case 'bar-raiser-evaluation':
      return <BarRaiserEvaluationPanel />;
    case 'about-stage':
      return <AboutStagePanel />;
    case 'info':
      return <InfoPanel />;
    case 'history':
      return <ActivityPanel />;
    case 'comments':
      return <CommentsPanel />;
    default:
      return null;
  }
}

/**
 * Top-level action panel component. Wraps Cloudscape PanelLayout and
 * renders the correct panel variant based on `activePanel`.
 *
 * Workflow and content are retrieved via context — no need to pass them as props.
 */
const ActionPanel = memo(function ActionPanel() {
  const state = useActionPanelState();
  return <>{renderPanel(state.activePanel)}</>;
});

export default ActionPanel;
